import AppCOLORS, { getColor } from "../../constant/ColorConfig";

const calendarColors = {
    completed: '#00C853',  
    active: '#00C853',  
    pending: '#FFC107',  
    cancelled: '#FF3B30', 
    announcement: '#9C27B0',  
    availability: '#2196F3',  
};
export const getCalendarEvents = (sessionList) => {
    let events = sessionList.map(list => {
        let eventColor =  getColor(list?.status);
        
        return {
            id: list?.id,
            title: `${list.user?.name ?? "Member"} w/ ${list.trainer?.name ?? "Trainer"}`,
            start: new Date(`${list?.date} ${list.start_time}`),
            end: new Date(`${list?.date} ${list.end_time}`),
            color: eventColor,
            status: list?.status,
            extendedProps: {
                type: 'session',
                ...list
            }
        }
    });
    return events;
};

function convertTo24H(timeStr) {
    const [time, modifier] = timeStr.split(" ");

    let [hours, minutes] = time.split(":");
    hours = parseInt(hours, 10);

    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    return `${hours.toString().padStart(2, "0")}:${minutes}:00`;
}
